import { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

const PagoMenu = (props) => {
  const { getComponent, backendSpecsActions, backendSpecsSelectors, pagoAuth2Selectors } = props;
  const [isHealthStatusOpen, setIsHealthStatusOpen] = useState(false);
  const [isSpecsManagerOpen, setIsSpecsManagerOpen] = useState(false);
  const [isSpecAccessOpen, setIsSpecAccessOpen] = useState(false);

  const DropdownMenu = getComponent('DropdownMenu');
  const DropdownMenuItem = getComponent('DropdownMenuItem');
  const DropdownMenuItemDivider = getComponent('DropdownMenuItemDivider');
  const HealthStatusMenuItem = getComponent('HealthStatusMenuItem', true);
  const HealthStatusDialog = getComponent('HealthStatusDialog', true);
  const SpecsManagerMenuItem = getComponent('SpecsManagerMenuItem', true);
  const SpecsManagerDialog = getComponent('SpecsManagerDialog', true);
  const SpecAccessDialog = getComponent('SpecAccessDialog', true);

  const isAdmin = pagoAuth2Selectors?.selectIsAdmin?.() || false;

  // Health status handlers
  const handleHealthStatusClick = useCallback((event) => {
    event.preventDefault();
    setIsHealthStatusOpen(true);
  }, []);

  const handleHealthStatusClose = useCallback(() => {
    setIsHealthStatusOpen(false);
  }, []);

  // Specs manager handlers
  const handleSpecsManagerClick = useCallback((event) => {
    event.preventDefault();
    setIsSpecsManagerOpen(true);
  }, []);

  const handleSpecsManagerClose = useCallback(() => {
    setIsSpecsManagerOpen(false);
  }, []);

  // Spec access handlers
  const handleSpecAccessClick = useCallback((event) => {
    event.preventDefault();
    setIsSpecAccessOpen(true);
  }, []);

  const handleSpecAccessClose = useCallback(() => {
    setIsSpecAccessOpen(false);
  }, []);

  return (
    <>
      {HealthStatusDialog && (
        <HealthStatusDialog
          isOpen={isHealthStatusOpen}
          onClose={handleHealthStatusClose}
          getComponent={getComponent}
          backendSpecsActions={backendSpecsActions}
          backendSpecsSelectors={backendSpecsSelectors}
        />
      )}
      {SpecsManagerDialog && (
        <SpecsManagerDialog
          isOpen={isSpecsManagerOpen}
          onClose={handleSpecsManagerClose}
          getComponent={getComponent}
          backendSpecsActions={backendSpecsActions}
          backendSpecsSelectors={backendSpecsSelectors}
        />
      )}
      {isAdmin && SpecAccessDialog && (
        <SpecAccessDialog
          isOpen={isSpecAccessOpen}
          onClose={handleSpecAccessClose}
          getComponent={getComponent}
          backendSpecsActions={backendSpecsActions}
          backendSpecsSelectors={backendSpecsSelectors}
        />
      )}
      <DropdownMenu label="Pago">
        {SpecsManagerMenuItem && (
          <SpecsManagerMenuItem getComponent={getComponent} onClick={handleSpecsManagerClick} />
        )}
        {isAdmin && (
          <>
            <DropdownMenuItemDivider />
            <DropdownMenuItem onClick={handleSpecAccessClick}>User Access</DropdownMenuItem>
          </>
        )}
        <DropdownMenuItemDivider />
        {HealthStatusMenuItem && (
          <HealthStatusMenuItem getComponent={getComponent} onClick={handleHealthStatusClick} />
        )}
      </DropdownMenu>
    </>
  );
};

PagoMenu.propTypes = {
  getComponent: PropTypes.func.isRequired,
  backendSpecsActions: PropTypes.object,
  backendSpecsSelectors: PropTypes.object,
  pagoAuth2Selectors: PropTypes.object,
};

export default PagoMenu;
